import { createContext } from 'react';

import { AltiboxProfile, Device, SubscriberWithToken } from '@modules/simulations/types';

export type SubscriberValues = {
  cancelLogin: VoidFunction;
  deviceList?: Device[];
  error?: string;
  handleLogin: (
    username: string,
    password: string,
    onError?: (error: string) => void
  ) => Promise<unknown>;
  handleLogout: VoidFunction;
  handleSelectDevice: (selectedDeviceId?: string) => Promise<void>;
  handleSelectProfile: (selectedSubscriberId?: string) => Promise<void>;
  isAuthenticating: boolean;
  profileOptions?: AltiboxProfile[];
  remainingSwaps?: number;
  subscriber?: SubscriberWithToken;
};

const SubscriberContext = createContext<SubscriberValues>({
  cancelLogin: () => void 0,
  handleLogin: () => new Promise(() => void 0),
  handleLogout: () => void 0,
  handleSelectDevice: () => new Promise(() => void 0),
  handleSelectProfile: () => new Promise(() => void 0),
  isAuthenticating: false,
});

export default SubscriberContext;
